import { Divider, TableBody, TableCell, TableContainer, TableHead } from '@mui/material'
import { Help, PageLayout, Pagination, Table, TableRow, TableWrapper, usePagination } from '@collaborate-health/uikit'
import credits from './data'

const CreditsPage: React.FC = () => {
  const { current, pages, size, onPageNumberChange, onPageSizeChange } = usePagination({
    total: credits.length,
    pageSize: 25,
  })
  const paginatedCredits = credits.slice((current - 1) * size, current * size)

  return (
    <PageLayout fullHeight maxWidth='lg' spacing='page' background='transparent'>
      <TableContainer>
        <TableWrapper>
          <Table stickyHeader size='small'>
            <TableHead>
              <TableRow>
                <TableCell align='center'>Component</TableCell>
                <TableCell align='center'>License type</TableCell>
                <TableCell align='center'>Link</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedCredits.map((credit) => (
                <TableRow key={credit.component}>
                  <TableCell align='center'>
                    <>
                      {credit.component}
                      {credit.notes && <Help title='Notes' text={credit.notes} />}
                    </>
                  </TableCell>
                  <TableCell align='center'>{credit.typeOfLicense}</TableCell>
                  <TableCell align='center'>
                    <a href={credit.linkToLicense} target='_blank' rel='noopener noreferrer'>
                      {credit.linkToLicense}
                    </a>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableWrapper>
        <Divider />
        <Pagination
          current={current}
          pages={pages}
          pageSize={size}
          onPageNumberChange={onPageNumberChange}
          onPageSizeChange={onPageSizeChange}
        />
      </TableContainer>
    </PageLayout>
  )
}

export default CreditsPage

